import { useState } from "react";
import { Button, DatePicker, InputNumber, Modal, Popover } from "antd";
import { ReactComponent as Interest } from "../../../images/interest.svg";
import { ReactComponent as Amount } from "../../../images/amount.svg";
import { ReactComponent as Fee } from "../../../images/fee.svg";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios/axios";
import { toast } from "react-toastify";
import FileUploadWithThumb from "../../../components/FileUploadWithThumb/FileUploadWithThum";
import dayjs from "dayjs";
import TextArea from "../../../components/Form/TextArea";

const FlooringDetails = ({
  FloorCaseDetails,
  openRejectPopup,
  AppId,
  AgentId,
  activeTab,
  GetFloorCaseDetails,
  pagePermission
}) => {
  const navigate = useNavigate();
  const [disbursmentOpen, setDisbursmentOpen] = useState(false);
  const [isissueAFF, setisissueAFF] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState({
    open: false,
    type: "payment",
  });
  const [disbursmentValues, setDisbursmentValues] = useState({
    flooring_start_date: "",
    remarks: "",
    disbursement_doc: [],
  });
  const [paymentValues, setPaymentValues] = useState({
    effective_date: null,
    amount: "",
    description: "",
    ledger_doc: [],
  });

  const Cart =
    Object.keys(FloorCaseDetails)?.length > 0 &&
      FloorCaseDetails?.cart["1"] !== undefined
      ? FloorCaseDetails?.cart["1"]?.agent
      : Array.isArray(FloorCaseDetails?.cart)
        ? FloorCaseDetails?.cart[0]?.agent
        : FloorCaseDetails?.cart;
  console.log("Cart========", Cart)
  const PaymentData = FloorCaseDetails?.ledger;

  const Reset = () => {
    setPaymentModalOpen(false);
    setPaymentValues({
      effective_date: null,
      amount: "",
      description: "",
      ledger_doc: [],
    });
  };
  const GetRedemptionCount = (max, redemedqty) => {
    const temp = max - redemedqty;
    if (temp > 0) {
      return temp;
    } else {
      return 0;
    }
  };

  const dataObj = {
    agent_admin_fee: Cart?.agent_admin_fee,
    agent_approved_status: Cart?.agent_approved_status,
    agent_interest_rate: Cart?.agent_interest_rate,
    agent_other_conditions: Cart?.agent_other_conditions,
    agent_voucher_approved_status: Cart?.agent_voucher_approved_status,
    intended_floor_amount: FloorCaseDetails?.vehicleInfo?.intended_floor_amount,
    preIssuedFloorAmount: FloorCaseDetails?.vehicleInfo?.pre_issued_floor_amount,
  };
  const SubmitDisbursement = async () => {
    const resp = await axios.post(
      `/flooring/application/Disbursement/${AppId?.appId}`,
      disbursmentValues
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setDisbursmentOpen(false);
      setDisbursmentValues({
        flooring_start_date: "",
        remarks: "",
        disbursement_doc: "",
      });
      navigate("/flooring-cases", {
        state: {
          ...AppId
        },
      });
    } else {
      toast.error("Error occured..!");
    }
  };
  const SubmitPayment = async () => {
    if (paymentModalOpen?.type === "payment") {
      const resp = await axios.post(
        `/flooring/application/addPayment/${AppId?.appId}`,
        paymentValues
      );
      if (resp.status < 400) {
        GetFloorCaseDetails();
        toast.success(resp.data?.message);
        setPaymentModalOpen({
          open: false,
          type: "payment",
        });
        Reset();
      } else {
        toast.error("Error occured..!");
      }
    } else {
      const resp = await axios.post(
        `flooring/application/addCharges/${AppId?.appId}`,
        paymentValues
      );
      if (resp.status < 400) {
        GetFloorCaseDetails();
        toast.success(resp.data?.message);
        setPaymentModalOpen({
          open: false,
          type: "payment",
        });
        Reset();
      } else {
        toast.error("Error occured..!");
      }
    }
  };

  const handleFileUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file[]", file);
    formData.append("module", "flooring");
    try {
      const response = await axios
        .post("/flooring/document", formData)
        .then((resp) => {
          setDisbursmentValues({
            ...disbursmentValues,
            disbursement_doc: disbursmentValues?.disbursement_doc?.concat(
              resp.data?.data
            ),
          });
          toast.success(resp.data?.message);
          onSuccess();
        });
    } catch (error) {
      onError(error);
    }
  };

  const OnLedgerUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file[]", file);
    formData.append("module", "flooring");
    try {
      const response = await axios
        .post("/flooring/document", formData)
        .then((resp) => {
          setPaymentValues({
            ...paymentValues,
            ledger_doc: resp.data?.data,
          });
          onSuccess();
        });
    } catch (error) {
      onError(error);
    }
  };

  const handleselAFF = async () => {
    const resp = await axios.post(
      `/flooring/application/approvalStatus/${AppId?.appId}`,
      {
        ...dataObj,
        agent_approved_status: 0,
        agent_voucher_approved_status: 0,
      }
    );
    // console.log("undo=======", resp)
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setisissueAFF(false);
      navigate("/flooring-cases", {
        state: {
          ...AppId
        },
      });
    }
  };
  let UndoInfoText = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <p className="my-[7px] text-[12px]">
        You have already issued AAF, you can only UNDO it before the dealer
        signs and accepts the AAF.
      </p>
    </div>
  );

  return (
    <div
      className={`flooring-details-section case-${Cart?.agent_approved_status === 0
        ? "pending"
        : Cart?.agent_approved_status === 1
          ? "issued"
          : Cart?.agent_approved_status === 2
            ? "rejected"
            : null
        }`}
    >
      <h2>Flooring Details</h2>
      <div className="flooring-details-block">
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon interest-block">
              <Interest />
            </div>
            <div className="details-card-info">
              <h3>Floor Interest (30 days)</h3>
              {Cart?.agent_approved_status == 1 ? (
                <h4>{FloorCaseDetails?.vehicleInfo?.floor_interest}%</h4>
              ) : (
                <h4>
                  {Cart?.product?.interest_from.slice(
                    0,
                    Cart?.product?.interest_from.indexOf(".") + 2
                  )}
                  % -{" "}
                  {Cart?.product?.interest_to.slice(
                    0,
                    Cart?.product?.interest_to.indexOf(".") + 2
                  )}
                  %
                </h4>
              )}
            </div>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon amount-block">
              <Amount />
            </div>
            <div className="details-card-info">
              <h3>Intended Floor Amount</h3>
              <h4>
                $
                {FloorCaseDetails?.vehicleInfo?.intended_floor_amount.slice(
                  0,
                  FloorCaseDetails?.vehicleInfo?.intended_floor_amount.indexOf(
                    "."
                  )
                )}
              </h4>
            </div>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon fee-block">
              <Fee />
            </div>
            <div className="details-card-info">
              <h3>Admin Fee</h3>
              {Cart?.agent_approved_status == 1 ? (
                <h4>
                  $
                  {/* {Cart?.agent_admin_fee.slice(
                    0,
                    Cart?.product?.admin_fee_from.indexOf(".")
                  )} */}
                  {Math.round(Cart?.agent_admin_fee)}
                </h4>
              ) : (
                <h4>
                  $
                  {Cart?.product?.admin_fee_from.slice(
                    0,
                    Cart?.product?.admin_fee_from.indexOf(".")
                  )}{" "}
                  - $
                  {Cart?.product?.admin_fee_to.slice(
                    0,
                    Cart?.product?.admin_fee_to.indexOf(".")
                  )}
                </h4>
              )}
            </div>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="preview-list">
            <h3>Status</h3>
            <span className="case-status-block">
              {Cart?.agent_approved_status === 0
                ? "Pending"
                : Cart?.agent_approved_status === 1
                  ? Cart?.dealer_approved_status == 1 &&
                    Cart?.agent_approved_status == 1
                    ? "Dealer Selected"
                    : "Issued"
                  : Cart?.agent_approved_status === 2
                    ? "Rejected"
                    : null}
            </span>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="preview-list !max-w-[100%]">
            <h3>Actions</h3>
            <div className="preview-btn-block">
              {pagePermission?.update_permission == 1 && Cart?.agent_approved_status !== 2 && (
                <Button
                  type="button"
                  className="sav_btn"
                  onClick={() => {
                    if (Cart?.agent_approved_status == 1) {
                      // console.log("call /flooring-cases/view/issueAAF/preview", dataObj)
                      navigate("/flooring-cases/view/issueAAF/preview", {

                        state: {
                          floorData: { FloorCaseDetails: FloorCaseDetails },
                          AppId: AppId,
                          dataObj: dataObj,
                          AgentId: AgentId,
                          issueAAf: false,
                        },
                      });
                    } else {
                      // console.log("call /flooring-cases/view/issueAAF", FloorCaseDetails?.vehicleInfo?.intended_floor_amount)
                      navigate("/flooring-cases/view/issueAAF", {
                        state: {
                          floorData: {
                            AppId: AppId,
                            FloorCaseDetails: FloorCaseDetails,
                          },
                          AppId: AppId,
                          intended_floor_amount: FloorCaseDetails?.vehicleInfo?.intended_floor_amount,
                          preIssuedFloorAmount: FloorCaseDetails?.vehicleInfo?.pre_issued_floor_amount,
                        },
                      });
                    }
                  }}
                >
                  {Cart?.agent_approved_status == 1 ? "View AAF" : "Issue AAF"}
                </Button>
              )}
              {pagePermission?.update_permission == 1 && Cart?.agent_approved_status == 1 && Cart?.dealer_approved_status !== 1 && (
                <>
                  <Button
                    className="sav_btn"
                    onClick={() => {
                      setisissueAFF(true);
                    }}
                    disabled={Cart.dealer_approved_status == 1}
                  >
                    Undo AAF
                  </Button>
                  <Popover content={UndoInfoText} placement="bottom">
                    <img
                      src="/images/fi_info.svg"
                      alt="info"
                      className="inline-block ml-[8px] cursor-pointer"
                    />
                  </Popover>
                </>
              )}
              {pagePermission?.update_permission == 1 && Cart?.dealer_approved_status == 1 &&
                Cart?.agent_approved_status == 1 &&
                PaymentData === undefined && (
                  <Button
                    type="button"
                    className="sav_btn"
                    onClick={() => setDisbursmentOpen(true)}
                  >
                    Disbursement
                  </Button>
                )}

              {pagePermission?.update_permission == 1 && Cart?.agent_approved_status !== 1 && (
                <Button
                  type="button"
                  className="sav_btn del_btn"
                  onClick={() =>
                    openRejectPopup(
                      true,
                      Cart?.agent_approved_status == 2 ? 0 : 2
                    )
                  }
                >
                  {Cart?.agent_approved_status == 2
                    ? "Undo Rejection"
                    : "Reject Application"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      {Cart?.is_voucher == 1 && (
        <div className="flooring-details-card">
          <h2 className="voucher-applied-block">
            <span>Voucher Applied</span>
          </h2>
          <h3>
            Interest Rate:{" "}
            <span>
              {Cart?.vouchers?.interest_rate.slice(
                0,
                Cart?.vouchers?.interest_rate.indexOf(".") + 2
              )}
              %
            </span>
          </h3>
          <h3>
            Eligible Floor Amt:{" "}
            <span>
              $
              {Cart?.vouchers?.amount_from.slice(
                0,
                Cart?.vouchers?.amount_from.indexOf(".")
              )}{" "}
              - $
              {Cart?.vouchers?.amount_to.slice(
                0,
                Cart?.vouchers?.amount_to.indexOf(".")
              )}
            </span>
          </h3>
          {Cart?.agent_voucher_approved_status == 0 && (
            <h3>
              Status: <span className='case-status-pending'>Pending</span>
            </h3>
          )}
          {Cart?.agent_voucher_approved_status == 1 && (
            <h3>
              Status: <span className='case-status-issued'>Accepted</span>
            </h3>
          )}
          {Cart?.agent_voucher_approved_status == 2 && (
            <h3>
              Status: <span className='case-status-rejected'>Rejected</span>
            </h3>
          )}

          <h3>
            Voucher(s) left:{" "}
            {Cart?.vouchers?.voucher_qty_type?.value == 0 ? (
              <span>{Cart?.vouchers?.voucher_qty_type?.label}</span>
            ) : (
              <span>{`${GetRedemptionCount(
                Cart?.vouchers?.redeemed_qty,
                Cart?.vouchers?.qty
              )} / ${Cart?.vouchers?.qty}`}</span>
            )}
          </h3>
        </div>
      )}
      <Modal
        open={disbursmentOpen}
        onCancel={() => {
          setDisbursmentValues({
            flooring_start_date: "",
            remarks: "",
            disbursement_doc: [],
          });
          setDisbursmentOpen(false);
        }}
        centered
        footer={null}
      >
        <div className="reject-popup-block">
          <h2 className="text-center">Disbursement</h2>
          <div className="flex flex-col">
            <label className="mb-1 text-sm font-medium text-gray-700">
              Floor Amount
            </label>
            <div className="px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-lg font-semibold">
              ${dataObj?.intended_floor_amount ?? "0.00"}
            </div>
          </div>
          <div className="flex flex-col">
            <label className="mb-1 text-sm font-medium text-gray-700">
              Flooring Start Date
            </label>
            <DatePicker
              placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY"
              className="!w-full h-[40px] !rounded-lg !border-gray-300 focus:!border-blue-500 focus:!shadow-sm"
              value={
                disbursmentValues.flooring_start_date
                  ? dayjs(disbursmentValues.flooring_start_date, "DD-MM-YYYY")
                  : null
              }
              onChange={(date, dateString) =>
                setDisbursmentValues((prev) => ({
                  ...prev,
                  flooring_start_date: date ? dateString : "",
                }))
              }
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </div>
          <TextArea
            label="Remarks"
            placeholder="Remarks"
            value={disbursmentValues?.remarks}
            onChange={(e) => {
              setDisbursmentValues({
                ...disbursmentValues,
                remarks: e.target.value,
              });
            }}
          />
          <FileUploadWithThumb
            label={"Disbursement document"}
            onFileUpload={() => { }}
            CustomFileUpload={handleFileUpload}
            maxCount={10}
            onRemove={(file) => {
              setDisbursmentValues({
                ...disbursmentValues,
                disbursement_doc: disbursmentValues?.disbursement_doc?.filter(
                  (it) => it?.name !== file?.name
                ),
              });
            }}
            isClose={disbursmentValues?.disbursement_doc?.length < 1}
          />
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                setDisbursmentValues({
                  flooring_start_date: "",
                  remarks: "",
                  disbursement_doc: [],
                });
                setDisbursmentOpen(false);
              }}
            >
              Close
            </Button>
            <Button
              className="sav_btn"
              onClick={() => {
                SubmitDisbursement();
              }}
              disabled={
                Object.values(disbursmentValues)?.filter(
                  (it) => it !== "" && it !== null
                )?.length < 3
              }
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        open={paymentModalOpen?.open}
        onCancel={() => {
          setPaymentModalOpen({ open: false, type: "payment" });
          Reset();
        }}
        centered
        footer={null}
      >
        <div className="reject-popup-block">
          <h2 className="text-center">Add {`${paymentModalOpen?.type}`}</h2>
          <div className="input-one-line">
            <div className="input-group">
              <label>Intended Floor Amount </label>
              <InputNumber
                type="number"
                prefix="$"
                value={paymentValues?.amount}
                prefixCls="sign_Icon"
                placeholder="0.00"
                precision={2}
                step="0.01"
                className="!w-full cusAdmInputNumber2 percentage_right arrHid"
                onChange={(val) =>
                  setPaymentValues({
                    ...paymentValues,
                    amount: val,
                  })
                }
              />
            </div>
            <div className="input-group">
              <label>Effective Date</label>
              <DatePicker
                placeholder="DD-MM-YYYY"
                format={"DD-MM-YYYY"}
                className={`py-[8px] w-full md:w-[225px] md:max-w-[230px]`}
                value={
                  paymentValues?.effective_date !== null &&
                    paymentValues?.effective_date !== undefined
                    ? dayjs(paymentValues?.effective_date, "DD-MM-YYYY")
                    : null
                }
                onChange={(date, dateString) => {
                  setPaymentValues({
                    ...paymentValues,
                    effective_date:
                      dateString !== null &&
                        dateString !== undefined &&
                        dateString !== ""
                        ? dateString
                        : null,
                  });
                }}
                disabledDate={(d) => d.isBefore(dayjs().subtract(1, "days"))}
              />
            </div>
          </div>
          <TextArea
            label="Description"
            placeholder="Description"
            value={paymentValues?.description}
            onChange={(e) => {
              setPaymentValues({
                ...paymentValues,
                description: e.target.value,
              });
            }}
          />
          <FileUploadWithThumb
            label={"Ledger Document"}
            onFileUpload={() => { }}
            CustomFileUpload={OnLedgerUpload}
            onRemove={(file) => {
              setPaymentValues({
                ...paymentValues,
                ledger_doc: paymentValues?.ledger_doc?.filter(
                  (it) => it?.name !== file?.name
                ),
              });
            }}
            maxCount={1}
            isClose={paymentValues?.ledger_doc?.length < 1}
          />
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                setPaymentModalOpen({ open: false, type: "payment" });
                Reset();
              }}
            >
              Close
            </Button>
            <Button
              className="sav_btn"
              onClick={() => {
                SubmitPayment();
              }}
              disabled={
                !(
                  paymentValues?.amount !== "" &&
                  paymentValues?.effective_date !== null
                )
              }
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        open={isissueAFF}
        onCancel={() => setisissueAFF(false)}
        centered
        footer={null}
      >
        <div className="reject-popup-block">
          <h2 className="text-center">
            {Cart?.agent_approved_status == 1
              ? "Undo Issuded AAF Application?"
              : "Issue AAF Application?"}
          </h2>
          {Cart?.agent_approved_status == 1 && (
            <h6>
              You have already issued AAF, you can only UNDO it before the
              dealer signs and accepts the AAF. Are you sure?
            </h6>
          )}
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                setisissueAFF(false);
              }}
            >
              Close
            </Button>
            <Button
              type="submit"
              className="sav_btn"
              onClick={() => {
                handleselAFF();
              }}
            >
              {Cart?.agent_approved_status == 1 ? "UNDO" : "Confirm"}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default FlooringDetails;
